import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import Modal from '@xo-union/tk-component-modals';
import Rsvpsetting from '../../../../libs/component-rsvp-settings';
import AnalyticsStore from '~/glm/models/analytics-store';
import GdsUiState from '~/glm/models/gds/gds-ui-state';
import EventCollection from '~/glm/models/gds/event-collection';
import GdsHouseholdCollection from '~/glm/models/gds/gds-household-collection';
import GuestListStore from '~/glm/models/guest-list-store';
import UserStore from '~/glm/models/user-store';
import styles from './rsvp-settings-modal.scss';

@inject('gdsUiState', 'gdsEvents', 'gdsHouseholds', 'userStore', 'guestListStore', 'analyticsStore')
@observer
class RsvpSettingsModal extends Component {
  static propTypes = {
    gdsEvents: PropTypes.instanceOf(EventCollection).isRequired,
    gdsUiState: PropTypes.instanceOf(GdsUiState).isRequired,
    gdsHouseholds: PropTypes.instanceOf(GdsHouseholdCollection).isRequired,
    userStore: PropTypes.instanceOf(UserStore),
    guestListStore: PropTypes.instanceOf(GuestListStore).isRequired,
    analyticsStore: PropTypes.instanceOf(AnalyticsStore).isRequired,
  };

  state = {
    saved: false,
  };

  componentDidMount() {
    const { gdsEvents } = this.props;

    const events = gdsEvents.map(e => {
      e.meals = e.mealQuestion && e.mealQuestion.options;
      return { ...e, meals: e.mealQuestion && e.mealQuestion.options };
    });

    this.setState({ events });
  }

  onSuccess = updatedWedding => {
    const { guestListStore, analyticsStore } = this.props;
    guestListStore.guestWedding.setProps(updatedWedding);
    analyticsStore.track('RSVP Settings Interaction', {
      action: 'save',
      security: 'private',
      source: 'guest list',
    });
    this.setState({ saved: true });
  };

  onCancel = () => {
    const { gdsUiState, analyticsStore, guestListStore } = this.props;
    const { saved } = this.state;

    if (saved === false) {
      analyticsStore.track('RSVP Settings Interaction', {
        action: 'cancel',
        rsvpPreference: get(guestListStore, ['guestWedding', 'isPrivateRsvp']) ? 'secure' : 'public',
        security: 'private',
        source: 'guest list',
      });
    }
    gdsUiState.setRsvpModalView(null);
  };

  onEventsUpdate = updatedEvents => {
    const { gdsEvents } = this.props;

    updatedEvents.forEach(updatedEvent => {
      const event = gdsEvents.get(updatedEvent.id);
      event.setProps(updatedEvent);
    });
  };

  onRsvpMount = () => {
    const { analyticsStore, guestListStore } = this.props;
    const rsvpPreference = get(guestListStore, ['guestWedding', 'isPrivateRsvp']) ? 'secure' : 'public';

    analyticsStore.track('RSVP Settings Interaction', {
      action: 'modal loaded',
      rsvpPreference,
      security: 'private',
      source: 'guest list',
    });
  };

  openEventModal = eventID => {
    const { gdsUiState, gdsEvents } = this.props;
    gdsUiState.setShowEventModal(true);
    gdsUiState.setSelectedEvent(gdsEvents.get(eventID));
    gdsUiState.setRsvpModalView(false);
  };

  goToGuestList = eventID => {
    const { gdsUiState, gdsEvents } = this.props;
    gdsUiState.setSelectedEvent(gdsEvents.get(eventID));
    gdsUiState.setRsvpModalView(false);
  };

  render() {
    const { guestListStore, gdsHouseholds, gdsEvents, userStore } = this.props;

    return (
      <div className={styles.rsvpSettingsContainer}>
        <Modal onClose={this.onCancel} size="lg">
          <Rsvpsetting
            guestWedding={guestListStore.guestWedding}
            events={gdsEvents}
            households={gdsHouseholds.values()}
            isPrivateRsvp={guestListStore.guestWedding.isPrivateRsvp}
            onSuccess={this.onSuccess}
            onEventsUpdate={this.onEventsUpdate}
            onCancelClick={this.onCancel}
            openEventModal={this.openEventModal}
            goToGuestList={this.goToGuestList}
            wwsState={userStore.wedding.state}
            hideCancel="true"
            onMount={this.onRsvpMount}
          />
        </Modal>
      </div>
    );
  }
}

export default RsvpSettingsModal;
